import Backbone from "backbone";

const RewardStateSummaryModel = Backbone.Model.extend({
    url: "/api/v2/rewards/state_summary",
});
export default RewardStateSummaryModel;
